import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import Toolbar from 'material-ui/Toolbar';
import {withStyles} from 'material-ui/styles';

const styles = theme => ({
	root: {
		marginBottom: theme.spacing.unit
	},
	title: {
		flex: 1
	}
});

const AdminListToolbar = ({classes, title, renderActions}) => (
	<Toolbar className={classes.root}>
		<Typography type="display2" className={classes.title}>
			{title}
		</Typography>
		{renderActions && renderActions(classes)}
	</Toolbar>
);

AdminListToolbar.propTypes = {
	classes: PropTypes.object.isRequired,
	title: PropTypes.string.isRequired,
	renderActions: PropTypes.func
};

export default withStyles(styles)(AdminListToolbar);




// WEBPACK FOOTER //
// ./src/client/components/admin/common/list-toolbar/index.jsx